export default __webpack_public_path__ + "static/Blitz22 01F430F8-3f1d5902b7f54c76076ad7ce9fc383e4.jpg";